































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Multiselect from 'vue-multiselect';
import { SourceTypeRequest } from '../../models/userdata/sourcetyperequest';
import {
  MULTI_SELECT,
  DROPDOWN,
  SHORT_TEXT,
} from '@/models/jobs/CustomFieldType';
@Component({
  components: {
    Multiselect,
  },
})
export default class SourceType extends Vue {
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  $wlToastr: any;
  customFieldsMetaData: any[] = [];
  private MULTI_SELECT = MULTI_SELECT;
  private DROPDOWN = DROPDOWN;
  private SHORT_TEXT = SHORT_TEXT;
  private WL_DEFAULT_VALUE = 'engage';

  async mounted() {
    vxm.users.getSourceTypeDetails().then((response) => {
      if (response && response.meta.success) {
        let responseData = response.data.customFields.candidateCustomMetaData;
        let sourceTypeMetaData = responseData.map((item) => {
          return this.formatResponse(item, responseData);
        });

        this.customFieldsMetaData = sourceTypeMetaData;
      }
    });
    this.bus.$on('on-next-step', this.onNextStep);
    this.$emit('disable-next-button', this.minimumEntries >= 0 ? this.isRequiredStep : true);
  }

  onValueSelect(selectedValue, customField, isMultiSelect) {
    if (selectedValue.value) {
      this.$emit('disable-next-button', false);
    }
    if (
      selectedValue.value === 'Other' &&
      customField.linkedFieldMetaData &&
      customField.linkedFieldMetaData.name
    ) {
      this.customFieldsMetaData = this.customFieldsMetaData.map((field) => {
        if (field.name === customField.linkedFieldMetaData.name) {
          field.visibility = true;
          field.required = true;
        }
        return field;
      });
    }
    if (
      !isMultiSelect &&
      selectedValue.value !== 'Other' &&
      customField.linkedFieldMetaData &&
      customField.linkedFieldMetaData.name
    ) {
      this.customFieldsMetaData = this.customFieldsMetaData.map((field) => {
        if (field.name === customField.linkedFieldMetaData.name) {
          field.visibility = false;
        }
        return field;
      });
    }
  }

  onValueRemoved(selectedValue, customField) {
    if (
      customField.defaultValue &&
      Array.isArray(customField.defaultValue) &&
      customField.defaultValue.length <= 1
    ) {
      this.$emit('disable-next-button', this.minimumEntries >= 0 ? this.isRequiredStep : true);
    }
    if (
      selectedValue.value === 'Other' &&
      customField.linkedFieldMetaData &&
      customField.linkedFieldMetaData.name
    ) {
      this.customFieldsMetaData = this.customFieldsMetaData.map((field) => {
        if (field.name === customField.linkedFieldMetaData.name) {
          field.visibility = false;
        }
        return field;
      });
    }
  }

  formatResponse(item, customFieldsMetaData) {
    if (item && [DROPDOWN, MULTI_SELECT].includes(item.type)) {
      let defaultValue = item.defaultValue;

      if (defaultValue) {
        if (item.defaultValue.toLowerCase() === this.WL_DEFAULT_VALUE) {
          item.defaultValue = '';
        } else {
          this.$emit('disable-next-button', false);
          item.defaultValue = defaultValue.split(',').map((item) => {
            return { text: item, value: item };
          });
        }
      }
      if (item.displayList && item.valueList) {
        let size = item.displayList.length;
        let optionsArr: any[] = [];
        for (let i = 0; i < size; i++) {
          let obj = {
            text: item.displayList[i],
            value: item.valueList[i],
          };
          optionsArr.push(obj);
        }
        item.options = optionsArr;
      }
      if (item.linkedFieldMetaData && item.linkedFieldMetaData.name) {
        customFieldsMetaData.map((customField) => {
          if (
            customField.name &&
            customField.name === item.linkedFieldMetaData.name
          ) {
            let defaultValue = item.defaultValue;
            if (defaultValue) {
              let OtherValue = Array.isArray(defaultValue)
                ? defaultValue.filter((item) => item.text === 'Other')
                : [];
              customField.visibility = OtherValue && OtherValue.length > 0;
              customField.required = OtherValue && OtherValue.length > 0;
            }
          }
        });
      }
    }
    return item;
  }

  async onNextStep() {
    if (this.validateForm()) {
      return;
    }
    const prepareRequestObject = this.prepareRequestObject();
    const response = await vxm.users.saveSourceTypeDetails(
      prepareRequestObject,
    );
    if (response.meta.success) {
      this.$wlToastr('success', this.$t('source-details-saved-message'), '');
      await vxm.users.validateMandatorySteps();
      if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
          this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
        }else{
          this.$emit('go-to-next');
        }
    } else {
      this.$wlToastr('error', this.$t('source-details-not-saved-message'), '');
    }
  }

  validateForm() {
    this.customFieldsMetaData = this.customFieldsMetaData.map((field) => {
      if (field.required && field.visibility && !field.defaultValue) {
        field.errorMessage = this.$t('this.field.required');
      } else {
        field.errorMessage = '';
      }
      return field;
    });
    return this.customFieldsMetaData.some((field) => {
      return field.errorMessage;
    });
  }

  prepareRequestObject(): SourceTypeRequest {
    let sourceTypeRequest = new SourceTypeRequest();
    let size = this.customFieldsMetaData.length;
    for (let i = 0; i < size; i++) {
      const customFieldObj = this.customFieldsMetaData[i];
      let customFieldValue = customFieldObj.defaultValue;
      if (
        customFieldObj &&
        customFieldObj.defaultValue &&
        Array.isArray(customFieldObj.defaultValue)
      ) {
        customFieldValue = customFieldObj.defaultValue
          .map((item) => item && item.value)
          .join(',');
      } else if (
        customFieldObj &&
        customFieldObj.defaultValue &&
        customFieldObj.defaultValue.text
      ) {
        customFieldValue = customFieldObj.defaultValue.value;
      }
      sourceTypeRequest.candidateCustomDataVo[
        customFieldObj.name
      ] = customFieldValue;
    }
    return sourceTypeRequest;
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }
}
